import { ChatPreferenceOptionsProps } from "./PreferenceChatDialog";
import { Chat } from "myfitworld-model";

function handleArchiveUnarchiveChat(updateUserMessagePreferences: any, chat: Chat, userId: string, action: 'archive'|'unarchive') {
  let userFirstData = chat.userFirstData;
  let userSecondData = chat.userSecondData;
  if(userFirstData.id === userId) {
    userFirstData = {
      ...userFirstData,
      archived: action === 'archive'
    };
  } else {
    userSecondData = {
      ...userSecondData,
      archived: action === 'archive'
    };
  }
  updateUserMessagePreferences({chatId: chat.id, userFirstData, userSecondData});
}



function handleDeleteChat(updateUserMessagePreferences: any, chat: Chat, userId: string) {
  let userFirstData = chat.userFirstData;
  let userSecondData = chat.userSecondData;
  if(userFirstData.id === userId) {
    userFirstData = {
      ...userFirstData,
      deleted: true,
      deletedDate: new Date()
    };
  } else {
    userSecondData = {
      ...userSecondData,
      deleted: true,
      deletedDate: new Date()
    };
  }
  updateUserMessagePreferences({chatId: chat.id, userFirstData, userSecondData});
}


export const chatPreferences: ChatPreferenceOptionsProps[] = [
  {
    id: "archive",
    label: "ARCHIVE_CHAT",
    title: 'archive_chat',
    dialogText: 'archive_chat_questions',
    onHandleAction: (updateUserMessagePreferences, chat, userId)=>{ handleArchiveUnarchiveChat(updateUserMessagePreferences, chat, userId, 'archive')},
  },
  {
    id: "unarchive",
    label: "UNARCHIVE_CHAT",
    title: "unarchive_chat",
    dialogText: "unarchive_chat_questions",
    onHandleAction: (updateUserMessagePreferences, chat, userId)=>{ handleArchiveUnarchiveChat(updateUserMessagePreferences, chat, userId, 'unarchive')},
  },
  {
    id: "delete",
    label: "DELETE_CHAT",
    title: "delete_chat",
    dialogText: "delete_chat_questions",
    onHandleAction: (updateUserMessagePreferences, chat, userId)=>{ handleDeleteChat(updateUserMessagePreferences, chat, userId)},
  },
];
